import React from 'react';
import { ClockIcon, PackageIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
export function TrustStats() {
  const stats = [{
    icon: ClockIcon,
    title: 'Emergency Parcel Delivery',
    description: 'Specialists in urgent, time-critical parcel transport.'
  }, {
    icon: PackageIcon,
    title: '5000+ Deliveries',
    description: 'Successfully completed across the UK.'
  }, {
    icon: MapPinIcon,
    title: 'Nationwide UK Coverage',
    description: 'Reaching every corner of the country.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Trusted Experts',
    description: 'Professional, vetted, and reliable drivers.'
  }];
  return <section className="py-12 bg-white relative z-20 -mt-16" data-id="element-182">
      <div className="container mx-auto px-4" data-id="element-183">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-184">
          {stats.map((stat, index) => {
          const Icon = stat.icon;
          return <div key={index} className="bg-white rounded-xl shadow-lg border border-slate-100 p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow" data-id="element-185">
                <div className="h-14 w-14 bg-blue-50 rounded-full flex items-center justify-center mb-4" data-id="element-186">
                  <Icon className="h-7 w-7 text-primary" data-id="element-187" />
                </div>
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-188">{stat.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-189">{stat.description}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}